import { ContentBox } from "@msuite/ui/content-box";
import { ReturnOrdersTable } from "@/components/stock/return-orders-table";

/**
 * The warehouse's return list: every site being cleared, and how much has come back off each.
 */
export function ReturnOrders() {
	/** Render */
	return (
		<ContentBox>
			<ReturnOrdersTable persistenceKey="data-return-orders-table" />
		</ContentBox>
	);
}
